import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Lock, Check, Zap, Sparkles, Clock } from 'lucide-react';
import { Button } from './Button';
import { offerIncludes } from '../data/includes';
import { CHECKOUT_URL, trackInitiateCheckout } from '../utils/tracking';
export function PricingSection() {
  return <section id="pricing" className="py-20 px-4 bg-sand border-y border-warmgray scroll-mt-8" data-id="element-193" data-mp="1ja0eo2sldvlt">
      <div className="max-w-3xl mx-auto" data-id="element-194" data-mp="1n9r525e7i9pt">
        <div className="text-center mb-10" data-id="element-195" data-mp="1s9n7i0799t39">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-3 text-charcoal" data-id="element-196" data-mp="1s8lrrifaoif7">
            Your Complete Offer Today
          </h2>
          <p className="text-terracotta-dark text-sm md:text-base" data-id="element-197" data-mp="1x6vqu4454363">
            The complete professional library for teaching art with confidence.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-paper border-2 border-terracotta rounded-3xl p-1 relative shadow-[0_16px_40px_-24px_rgba(138,74,43,0.45)]" data-id="element-198" data-mp="2w9z9zw0vkwv">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-terracotta-deep text-paper font-bold px-5 py-1.5 rounded-full uppercase tracking-wider text-xs flex items-center gap-1.5 whitespace-nowrap" data-id="element-199" data-mp="17stnu03blf9w">
            <Sparkles size={14} aria-hidden="true" data-id="element-200" data-mp="20gz70ieq6w7m" /> Complete Library
          </div>

          <div className="bg-paper rounded-[1.3rem] p-6 md:p-10 text-center" data-id="element-201" data-mp="1vgbdnq30y3a8">
            <h3 className="text-2xl md:text-3xl font-serif font-bold text-terracotta mb-3" data-id="element-202" data-mp="1rgauxt8w75xd">
              Art Teacher Ready
            </h3>

            <ul className="text-left max-w-md mx-auto space-y-2 mb-6 bg-sand border border-warmgray rounded-xl p-4" data-id="element-203" data-mp="k3ircut0671k">
              {offerIncludes.map(item => <li key={item} className="flex items-start gap-2 text-sm text-charcoal-soft" data-id="element-204" data-mp="hhhzczxtm8cp">
                  <Check size={16} className="text-terracotta shrink-0 mt-0.5" aria-hidden="true" data-id="element-205" data-mp="merxr536tuco" />
                  <span data-id="element-206" data-mp="ch3t9nfs58hb">{item}</span>
                </li>)}
            </ul>

            <div className="mb-4" data-id="element-207" data-mp="3uvwa8xkq39aa">
              <span className="text-lg text-charcoal-muted line-through block mb-1" data-id="element-208" data-mp="3uuth0izxgur7">
                Regular price: $137.00
              </span>
              <div className="flex flex-wrap items-baseline justify-center gap-2" data-id="element-209" data-mp="3kzjg5yl9mtf0">
                <span className="text-2xl md:text-3xl text-charcoal" data-id="element-210" data-mp="3px1t002elssa">
                  YOUR PRICE TODAY:
                </span>
                <span className="text-4xl md:text-5xl font-bold text-burnt" data-id="element-211" data-mp="3bz3d2q8fpoao">
                  $27.00
                </span>
              </div>
            </div>

            <p className="text-sm text-charcoal-muted mb-5" data-id="element-212" data-mp="2xatpnhmdiqfe">
              Pay once. Use forever. Digital access—no shipping, no delays.
            </p>

            <p className="inline-flex items-center gap-2 bg-terracotta-deep text-paper text-xs font-bold uppercase tracking-wider rounded-full px-4 py-2 mb-6" data-id="element-213" data-mp="2sduucvqz4dfm">
              <Clock size={14} aria-hidden="true" data-id="element-214" data-mp="31cf59aqalita" /> Launch pricing ends in 24
              hours
            </p>

            <Button href={CHECKOUT_URL} target="_blank" onLinkClick={trackInitiateCheckout} className="w-full md:w-auto text-base md:text-lg py-4 px-8 mb-5" data-id="element-215" data-mp="3g8o44b69tu56">
              GET ART TEACHER READY NOW
            </Button>

            <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-charcoal-muted" data-id="element-216" data-mp="3l1qnxrl8xp86">
              <span className="flex items-center gap-1.5" data-id="element-217" data-mp="2w47j904xn2p">
                <Lock size={12} className="text-terracotta" aria-hidden="true" data-id="element-218" data-mp="3u1dtmpl0dh71" />{' '}
                Safe, encrypted payment
              </span>
              <span className="flex items-center gap-1.5" data-id="element-219" data-mp="lz603gwenozd">
                <Zap size={12} className="text-terracotta" aria-hidden="true" data-id="element-220" data-mp="lxl4rp29o20g" />{' '}
                Instant access
              </span>
              <span className="flex items-center gap-1.5" data-id="element-221" data-mp="vq0pgu4y74p1">
                <Shield size={12} className="text-terracotta" aria-hidden="true" data-id="element-222" data-mp="vrligfbm6fks" />{' '}
                7-day guarantee
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}